import React from 'react'

import { OfflineBanner } from '@containers/OfflineBanner'

import { AssignmentsSection } from '../AssignmentsSection'
import { BarriersSection } from '../BarriersSection'
import { FutureTaskBanner } from '../FutureTaskBanner'
import { JobSection } from '../JobSection'
import { TaskSection } from '../TaskSection'
import { Container } from './styles'

export function TaskContainer() {
  return (
    <>
      <OfflineBanner />
      <FutureTaskBanner />
      <Container
        style={{ paddingBottom: 20, overflowY: 'auto' }}
      >
        <JobSection />
        <TaskSection />
        <AssignmentsSection />
        <BarriersSection />
      </Container>
    </>
  )
}
